import type { App, Plugin } from 'vue'
import { watch } from 'vue'
import { useUserStore } from '@/store/user'
import { loadAiView } from '@/router'

const idle = (cb: () => void) =>
  'requestIdleCallback' in window
    ? requestIdleCallback(cb, { timeout: 2000 })
    : setTimeout(cb, 800)

// Prefetch le chunk IA dès que l'utilisateur a l'IA activée, pour que déclencher
// un skill IA depuis l'omnibox n'attende jamais un aller-retour réseau. Les
// utilisateurs sans IA ne le téléchargent jamais.
const AiPrefetch: Plugin = {
  install(_app: App) {
    const userStore = useUserStore()
    watch(
      () => userStore.aiEnabled,
      enabled => {
        if (enabled)
          idle(() => {
            void loadAiView()
          })
      },
      { immediate: true }
    )
  }
}

export default AiPrefetch
